module.exports = "/_next/static/images/Hero-f3c6adedf0215cbf3cf4eb6fa20d8210.webp";